import React, { useState, useEffect } from 'react';
import './Statistics.css';
import { getBeltImage, getBeltColor } from './utils/beltHelper';
import UserBadges from './components/UserBadges';
import './components/UserBadges.css';

function Statistics({ onClose }) {
  const [profile, setProfile] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
      
      const [profileRes, sessionsRes] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}/profile`, {
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Cache-Control': 'no-cache'
          }
        }),
        fetch(`${process.env.REACT_APP_API_URL}/profile/sessions`, {
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Cache-Control': 'no-cache'
          }
        })
      ]);

      if (profileRes.ok && sessionsRes.ok) {
        const profileData = await profileRes.json();
        const sessionsData = await sessionsRes.json();
        console.log('Profile Data:', profileData);
        console.log('Sessions Data:', sessionsData);
        setProfile(profileData);
        setSessions(sessionsData);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };



  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  };

  if (loading) {
    return (
      <div className="overlay">
        <div className="stats-container">
          <div className="stats-loading">⏳ Cargando...</div>
        </div>
      </div>
    );
  }

  const trainingStats = sessions.filter(s => s.modo === 'entrenamiento');
  const combatStats = sessions.filter(s => s.modo === 'combate');

  return (
    <div className="overlay" onClick={onClose}>
      <div className="stats-container" onClick={(e) => e.stopPropagation()}>
        <div className="stats-header">
          <h2>📊 ESTADÍSTICAS</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="stats-content">
          <div className="stats-grid">
            {/* Stats de Combate */}
            <div className="stats-card">
              <h3>⚔️ Estadísticas de Combate</h3>
              <div className="stat-row">
                <span className="stat-icon">💪</span>
                <span className="stat-label">Fuerza</span>
                <span className="stat-value">{profile?.fuerza_total || profile?.fuerza || 10}</span>
              </div>
              <div className="stat-row">
                <span className="stat-icon">🎯</span>
                <span className="stat-label">Habilidad</span>
                <span className="stat-value">{profile?.habilidad_total || profile?.habilidad || 10}</span>
              </div>
              <div className="stat-row">
                <span className="stat-icon">🥋</span>
                <span className="stat-label">Técnica</span>
                <span className="stat-value">{profile?.tecnica_total || profile?.tecnica || 10}</span>
              </div>
              <div className="stat-row">
                <span className="stat-icon">⚡</span>
                <span className="stat-label">Velocidad</span>
                <span className="stat-value">{profile?.velocidad_total || profile?.velocidad || 10}</span>
              </div>
              <div className="stat-row">
                <span className="stat-icon">🛡️</span>
                <span className="stat-label">Defensa</span>
                <span className="stat-value">{profile?.defensa_total || 0}</span>
              </div>
            </div>

            {/* Perfil y Progreso */}
            <div className="stats-card profile-card">
              <h3>👤 Perfil</h3>
              <div className="profile-info">
                <div className="profile-avatar">
                  {profile?.avatar ? (
                    <img src={profile.avatar} alt="Avatar" />
                  ) : (
                    <span>👤</span>
                  )}
                </div>
                <div className="profile-details">
                  <h4>{profile?.nombre}</h4>
                  {/* Debug: mostrar datos del perfil */}
                  {console.log('Profile data for badges:', {
                    torneo_marcial_completado: profile?.torneo_marcial_completado,
                    combates_ia_ganados: profile?.combates_ia_ganados,
                    combate_4dan_ganado: profile?.combate_4dan_ganado,
                    combate_maestro_ganado: profile?.combate_maestro_ganado,
                    combate_granmaster_ganado: profile?.combate_granmaster_ganado
                  })}
                  <UserBadges user={profile} size="large" />
                  {getBeltImage(profile?.cinturon) ? (
                    <img 
                      src={getBeltImage(profile?.cinturon)} 
                      alt={profile?.cinturon} 
                      className="belt-image"
                      title={profile?.cinturon}
                    />
                  ) : (
                    <div className="belt-badge" style={{ background: getBeltColor(profile?.cinturon), color: profile?.cinturon?.includes('Negro') ? '#fff' : '#000' }}>
                      {profile?.cinturon || 'Cinturón Blanco'}
                    </div>
                  )}
                  <p>Nivel {profile?.nivel || 1}</p>
                  <div className="profile-stats">
                    <p>💰 {profile?.monedas || 0} Monedas</p>
                    <p>🔋 {profile?.energia || 100}/100 Energía</p>
                    <p>⚡ {profile?.xp || 0} XP</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Rendimiento */}
            <div className="stats-card performance-card">
              <h3>📈 Rendimiento General</h3>
              <div className="stat-box">
                <div className="stat-number">{profile?.partidas_jugadas || 0}</div>
                <div className="stat-desc">Partidas</div>
              </div>
              <div className="stat-box">
                <div className="stat-number">{Math.floor((profile?.tiempo_total_jugado || 0) / 60)}m</div>
                <div className="stat-desc">Tiempo Total</div>
              </div>
              <div className="stat-box">
                <div className="stat-number">{profile?.mejor_score || 0}</div>
                <div className="stat-desc">Mejor Score</div>
              </div>
            </div>

            {/* XP */}
            <div className="stats-card xp-card">
              <h3>⚡ Experiencia</h3>
              <div className="xp-content">
                <div className="xp-display">
                  <div className="xp-number">{profile?.xp || 0}</div>
                  <div className="xp-label">XP Total</div>
                </div>
                <div className="xp-progress-container">
                  <div className="xp-progress-info">
                    <span>{(profile?.xp || 0) % 100} / 100 XP</span>
                    <span>{((profile?.xp || 0) % 100)}%</span>
                  </div>
                  <div className="xp-progress-bar">
                    <div className="xp-progress-fill" style={{ width: `${((profile?.xp || 0) % 100)}%` }}></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Por Modo */}
            <div className="stats-card mode-stats">
              <h3>🎮 Por Modo de Juego</h3>
              <div className="mode-grid">
                <div className="mode-section">
                  <h4>Entrenamiento</h4>
                  <p>Sesiones: {trainingStats.length}</p>
                  <p>Score Promedio: {trainingStats.length > 0 ? Math.round(trainingStats.reduce((a, b) => a + b.score, 0) / trainingStats.length) : 0}</p>
                </div>
                <div className="mode-section">
                  <h4>Combate</h4>
                  <p>Sesiones: {combatStats.length}</p>
                  <p>Score Promedio: {combatStats.length > 0 ? Math.round(combatStats.reduce((a, b) => a + b.score, 0) / combatStats.length) : 0}</p>
                </div>
                <div className="mode-section">
                  <h4>Rotura</h4>
                  <p>Sesiones: {sessions.filter(s => s.modo === 'rotura').length}</p>
                  <p>Score Promedio: {sessions.filter(s => s.modo === 'rotura').length > 0 ? Math.round(sessions.filter(s => s.modo === 'rotura').reduce((a, b) => a + b.score, 0) / sessions.filter(s => s.modo === 'rotura').length) : 0}</p>
                </div>
                <div className="mode-section">
                  <h4>Palmetas</h4>
                  <p>Sesiones: {sessions.filter(s => s.modo === 'palmetas').length}</p>
                  <p>Score Promedio: {sessions.filter(s => s.modo === 'palmetas').length > 0 ? Math.round(sessions.filter(s => s.modo === 'palmetas').reduce((a, b) => a + b.score, 0) / sessions.filter(s => s.modo === 'palmetas').length) : 0}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Statistics;
